import { SET_WORKFLOW_STEPS, SET_WORKFLOW_STEPS_LOADING } from './actions'
import { IWorkflowStepDetails } from "../common/types"
import { IStringNumberMap } from "../../../common/defaults"


export interface IWorkflowState {
    WorkFlowStepsLoading:boolean;
    WorkFlowSteps: IStringNumberMap;
}
  

const initialState: IWorkflowState = {
    WorkFlowStepsLoading:false,
    WorkFlowSteps: null
};

const QueueReducer = (state: IWorkflowState = initialState, action) => {
    let _state = { ...state };
    switch (action.type) {
        case SET_WORKFLOW_STEPS:
            let workflowSteps:IStringNumberMap = {};
            (action.value as Array<IWorkflowStepDetails>).forEach(workflowItem => {
                workflowSteps[workflowItem.name.replace(/\s/g,'')] = workflowItem.id;  
            });
            _state.WorkFlowSteps = workflowSteps;
            return _state;
        case SET_WORKFLOW_STEPS_LOADING:
            _state.WorkFlowStepsLoading = action.value;
            return _state;
        default:
            return state;
    }
};

export default QueueReducer;
